import { useState, useMemo, useCallback, useEffect } from 'react';
import { useTimeout } from 'hooks/timeout';

const SPLASH_PHASE = {
  LOADING: 'loading',
  EXITING: 'exiting',
  DISMISSING: 'dismissing',
  DONE: 'done',
};

const INTRO_DURATION = 1400;
const LOADING_TIMEOUT = 15000;

const TRANSITION_DURATION = {
  [SPLASH_PHASE.EXITING]: 1100,
  [SPLASH_PHASE.DISMISSING]: 300,
};

const KorioSplash = ({ isReady, hasPanel }) => {
  const [phase, setPhase] = useState(SPLASH_PHASE.LOADING);

  const splashElement = useMemo(() => document.getElementById('korio-splash'), []);

  const exit = useCallback(() => {
    setPhase(hasPanel ? SPLASH_PHASE.EXITING : SPLASH_PHASE.DISMISSING);
  }, [hasPanel]);

  const finish = useCallback(() => {
    setPhase(SPLASH_PHASE.DONE);
  }, []);

  const exitDelay = useMemo(() => {
    if (phase !== SPLASH_PHASE.LOADING || !isReady) return null;

    return hasPanel ? Math.max(0, INTRO_DURATION - performance.now()) : 0;
  }, [phase, isReady, hasPanel]);

  const loadingTimeoutDelay = useMemo(() => {
    return phase === SPLASH_PHASE.LOADING ? LOADING_TIMEOUT : null;
  }, [phase]);

  const finishDelay = useMemo(() => TRANSITION_DURATION[phase] ?? null, [phase]);

  useTimeout(exit, exitDelay);
  useTimeout(exit, loadingTimeoutDelay);
  useTimeout(finish, finishDelay);

  useEffect(() => {
    if (!splashElement) return;

    if (phase === SPLASH_PHASE.DONE) {
      splashElement.remove();
    } else {
      splashElement.dataset.phase = phase;
    }
  }, [splashElement, phase]);

  return null;
};

export default KorioSplash;
